import React from "react";
import EditButton from "./EditButton";
import { rmeRows, rmeCols, getRmeField } from "./rmeTableUtils";
import { formatDisplayValue } from "./simulatorUtils";

const BORDER_COLOR = "#12b2ab"; // couleur fin_reelle (cf. mouvementBorderColors)

const FlotteRmeTable = ({
  projection,
  index,
  updateRmeField,
  externalValues,
}) => {
  const CELL_WIDTH = 110;
  const LABEL_WIDTH = 130;

  return (
    <div
      style={{
        background: "#f8f9fa",
        borderLeft: `3px solid ${BORDER_COLOR}`,
        padding: "8px 12px",
        margin: "4px 0",
        display: "inline-block",
      }}
    >
      <table
        className="table table-sm mb-0"
        style={{
          background: "transparent",
          width: "auto",
          tableLayout: "fixed",
        }}
      >
        <thead>
          <tr>
            <th
              style={{ width: LABEL_WIDTH, background: "transparent" }}
            ></th>
            {rmeCols.map((col) => (
              <th
                key={col.id}
                style={{
                  width: CELL_WIDTH,
                  background: "transparent",
                  fontWeight: 600,
                  fontSize: 12,
                  padding: "4px 8px",
                }}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rmeRows.map((row) => (
            <tr key={row.id}>
              <td
                style={{
                  fontWeight: 600,
                  background: "transparent",
                  fontSize: 12,
                  padding: "4px 8px",
                }}
              >
                {row.title}
              </td>
              {rmeCols.map((col) => {
                const field = getRmeField(row.id, col.id);
                const value = projection[field];
                return (
                  <td
                    key={col.id}
                    style={{
                      background: "transparent",
                      fontSize: 12,
                      padding: "4px 8px",
                    }}
                  >
                    {col.editable ? (
                      <EditButton
                        projectionIndex={index}
                        field={field}
                        value={value}
                        updateProjection={updateRmeField}
                        externalValues={externalValues}
                        calculatedValues={projection.calculatedValues}
                      />
                    ) : (
                      formatDisplayValue(field, value)
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FlotteRmeTable;
